var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryRound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7180_905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.26 2.99995C8.17003 2.85995 4.00003 6.94995 4.00003 12H2.21003C1.76003 12 1.54003 12.54 1.86003 12.85L4.65003 15.65C4.85003 15.8499 5.16003 15.8499 5.36003 15.65L8.15003 12.85C8.46003 12.54 8.24003 12 7.79003 12H6.00003C6.00003 8.09995 9.18003 4.94995 13.1 4.99995C16.82 5.04995 19.95 8.17995 20 11.9C20.05 15.8099 16.9 19 13 19C11.39 19 9.90003 18.45 8.72003 17.52C8.32003 17.21 7.76003 17.24 7.40003 17.6C6.98003 18.02 7.01003 18.73 7.48003 19.09C9.00003 20.29 10.91 21 13 21C18.05 21 22.14 16.83 22 11.74C21.87 7.04995 17.95 3.12995 13.26 2.99995ZM12.75 7.99995C12.34 7.99995 12 8.33995 12 8.74995V12.43C12 12.78 12.19 13.11 12.49 13.29L15.61 15.14C15.97 15.35 16.43 15.23 16.64 14.88C16.85 14.52 16.73 14.06 16.38 13.85L13.5 12.14V8.73995C13.5 8.33995 13.16 7.99995 12.75 7.99995Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7180_905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryRound);
export default __webpack_public_path__ + "static/media/history-round.26a875d4787c7c8cacb62a7ad632ac37.svg";
export { ForwardRef as ReactComponent };